import React, { useEffect, useState ,useReducer} from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


import { getUnreadNotification, updateNotificationStatus } from "../../../services/user";
import { ROLES } from "../../../constant/commonConstants";
import CommonButton from "../../commonFields/CommonButton";
import notificationList from "../../../services/notification";
import ROUTES from "../../../constant/routes";
import listReducer, { initialListState, INotification } from "../../../store/ListReducer";
import SVGFiles from "../../SVGFiles";

import { authStore } from "../../../store/authStore";

const HeaderAdmin: React.FC = () => {
  const navigate = useNavigate();
  const { t: translation } = useTranslation();
  const [unreadNotification, setUnreadNotification] = useState(0);
  const [loading, setLoading] = useState(false);
  const [notifactionData,dispatch]=useReducer(listReducer,initialListState);


  const { state:authUser } = authStore((state) => state);

  const gettingUndreaCounts=async(userType:string)=>{
    if(userType){
      const {data}=await getUnreadNotification({userType});
      if(data?.success){
        setUnreadNotification(data?.data);
      }
    }
  }

  const getNotificationList = async (firstLoad: boolean) => {
    if (notifactionData.offset !== notifactionData.prevOffset || firstLoad) {
      setLoading(true);
      const options = {
        offset: firstLoad ? 0 : firstLoad ? 0 : notifactionData.offset,
        type: authUser.account_type,
      };
      const {data} = await notificationList(options);
      if(data?.success){
        dispatch({
          type:"LIST",
          payload:{
            ...notifactionData,
            list:data?.data,
          },
          firstLoad,
        });
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    gettingUndreaCounts(authUser.account_type as string);
    const interval = setInterval(() => {
      gettingUndreaCounts(authUser.account_type as string);
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  useEffect(()=>{
    getNotificationList(true);
  },[window?.location?.pathname])

  const handleClick = () => {
    setUnreadNotification(0);
    navigate(ROUTES.NOTIFICATION);
  };

  const notificationHandler=async(args:string,notificationId:number)=>{
    const orderId=args?.split(": ")[1]?.split(" ")[0];
    if(orderId){
      if(unreadNotification>0){
        const {data:res}= await updateNotificationStatus({
          userType: authUser.account_type as string,
          notificationId
        });
        if(res?.success){
          setUnreadNotification(res?.data)
        }
      }
      navigate(
        authUser?.account_type===ROLES.ADMIN ?
        ROUTES.ORDER_DETAIL.replace(":orderId",orderId):
        ROUTES.ARTWORK_LIST.replace(":orderId",orderId)
      );
    }
  };

  return (
    <div className="white-card">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h3 className="color-secondary">
            <b>
              {new Date().getHours() < 12
                ? translation("good_morning")
                : new Date().getHours() < 17
                ? translation("good_afternoon")
                : translation("good_evening")}
            </b>
          </h3>
        </div>
        <div className="notify-list-set">
          <CommonButton
            className="theme-button round-btn"
            type="button"
            onClick={() => handleClick()}
          >
            <SVGFiles name="bellIcon" />
            {unreadNotification > 0 && <span>{unreadNotification}</span>}
          </CommonButton>
          <ul>
            {notifactionData?.list?.length > 0
              ? notifactionData.list.map((notification: INotification) => (
                  <li>
                    <SVGFiles name="notificationListIcon" />
                    <p
                      onClick={() => notificationHandler(notification?.message,notification.id)}
                      className={`cursor-pointer ${notification.status==="unread" ? 
                        "bold-text":""}`}
                    >
                      {notification?.message}
                    </p>
                  </li>
                ))
              : !loading && (
                  <p className="text-center">{translation("no_record")}</p>
                )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HeaderAdmin;
